import React from 'react';
function AlignJustify({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 10H3M21 6H3M21 14H3M21 18H3" />
    </svg>
  );
}

export default AlignJustify;
